export default "/static/dashboard/build/app/img/v2/22f4a2456cfb2ac074e5984ab93f048d.png";